import {Box, Button, MenuItem, Select, styled} from "@mui/material";
import Base from "../../../../../../components/base";
import {
  buildPath,
  formatDateInfo,
  getFasciaAmPmById,
  getTurnoHourById,
  PHONE_PREFIXES,
  scale,
  splitPhoneNumber,
  validatePhoneNumber,
  validateTaxCode
} from "../../../../../../utils";
import BaseHeader from "../../../../../../components/base/header";
import BaseTitle from "../../../../../../components/base/title";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import DateDetailedCard from "../../../../../../components/date-detailed-card";
import Text from "../../../../../../components/text";
import theme, {FONTS} from "../../../../../../constants/theme";
import React, {useEffect, useState} from "react";
import DateRowInfo from "../../../../../../components/date-row-info";
import CustomSvg from "../../../../../../components/custom-svg";
import {GOCCIA_RIFLESSO} from "../../../../../../constants/svgs";
import ThemedTextInput from "../../../../../../components/input/text";
import ThemedText from "../../../../../../components/text";
import {addNewDonor, fetchRaccoltaById} from "../../../../../../features/operator";
import {NewDonorRequest, RaccoltaResponse} from "../../../../../../types";
import { QueryBuilder } from "@mui/icons-material";
import {useMediaQuery} from "@mui/system";
import LABEL from "../../../../../../resources/label";

const Wrapper = styled(Box)({

});

const ContentWrapper = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  marginTop: scale(65),
  gap: scale(57),
  height: scale(480 + 138),
  width: '100%',
  marginLeft: scale(220),
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
    height: scale(530),
  },
});

const inputSx = {
  input: {
    sx: {
      fontFamily: FONTS.MONTSERRAT,
      color: 'black',
      fontWeight: 300,
      fontSize: scale(16),
      height: scale(51.14),
      width: scale(270.5),
      boxSizing: 'border-box',
      borderRadius: 0,
      '& input': {
        paddingTop: scale(7),
        paddingLeft: scale(8),
        paddingBottom: scale(6),
      },
    },
  },
}

const ThemedButton = styled(Button)({
  borderRadius: scale(30),
  width: scale(170),
  height: scale(52),
  marginBottom: scale(28),
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.lightGray.main,
    cursor: 'not-allowed',
  },
});

const OperatoreRiepilogoPrenotazione = () => {
  const { raccoltaId } = useParams<{ raccoltaId: string }>();
  const navigate = useNavigate();
  const [raccolta, setRaccolta] = useState<RaccoltaResponse | null>(null)
  const [partialDonorInfo, setPartialDonorInfo] = useState<Partial<NewDonorRequest> | null>(null)
  const [fistNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [cfError, setCFError] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phonePrefix, setPhonePrefix] = useState('+39');
  const [phone, setPhone] = useState('');
  const [cf, setCf] = useState('');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileStep, setMobileStep] = useState<1 | 2>(1);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();
  const path = location.pathname;

  const isOperatore = path.includes('operatore');
  const nextUrl = isOperatore ? `/operatore/dettaglio-raccolta/${raccoltaId}/aggiungi-donatore/selezione-orari/riepilogo-prenotazione/esito-prenotazione` : `/donatore/raccolta/${raccoltaId}/selezione-orari/riepilogo-prenotazione/esito-prenotazione`



  useEffect(() => {
    fetchRaccoltaById(Number(raccoltaId)).then((res) => {
      setRaccolta(res);
      const stored = sessionStorage.getItem('newDonorInfo')
      if (stored) {
        const parsedStored = JSON.parse(stored) as Partial<NewDonorRequest>
        setPartialDonorInfo(parsedStored)
        if (parsedStored?.donorInfo) {
          const {prefix, number} = splitPhoneNumber(parsedStored.donorInfo.phone);
          setFirstName(parsedStored.donorInfo.firstName);
          setLastName(parsedStored.donorInfo.lastName);
          setPhonePrefix(prefix);
          setPhone(number);
          setCf(parsedStored.donorInfo.CF);
        }
      } else {
        //TODO
        navigate(isOperatore ? buildPath(`/operatore/dettaglio-raccolta/${raccoltaId}/aggiungi-donatore`) : buildPath(`/donatore/raccolta/${raccoltaId}`))
      }
    })

  }, [isOperatore, navigate, raccoltaId])


  if (!raccolta || !partialDonorInfo) {
    return null;
  }

  const props = isMobile
    ? {
      isMobile: true as const,
      type: partialDonorInfo.type as 'sangue' | 'plasma',
    }
    : {
      isMobile: false as const,
    };

  const dateInfo = formatDateInfo(raccolta.date)
  const mobileDateInfo = {
    day: raccolta.date.toString().slice(-2),
    month: raccolta.date.toString().slice(-5, -3),
    year: raccolta.date.toString().slice(0, 4),
  }

  const isDisabled = (): boolean => {
    return (phoneError || cfError || fistNameError || lastNameError || !firstName.trim() || !lastName.trim() || !phone.trim())
  }

  const addDonorToRaccolta = () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    const info: Partial<NewDonorRequest> = {
      ...partialDonorInfo,
      donorInfo: {
        firstName: firstName,
        lastName: lastName,
        phone: `${phonePrefix.trim()}${phone.trim()}`,
        CF: cf,
      }
    }
    addNewDonor(info).then(() => {
      sessionStorage.setItem('newDonorResult', JSON.stringify({status: true}));
      navigate(buildPath(nextUrl))
    }).catch((e: Error) => {
      try {
        const errorJson = JSON.parse(e.message);
        if (errorJson.message && (e.message.includes('409') || errorJson.message.includes('Prenotazione già effettuata'))) {
          sessionStorage.setItem('newDonorResult', JSON.stringify({status: 'conflict', message: errorJson.message}));
          navigate(buildPath(nextUrl))
        } else {
          sessionStorage.setItem('newDonorResult', JSON.stringify({status: false}));
          navigate(buildPath(nextUrl))
        }
      } catch {
        if (e.message.includes('409')) {
          sessionStorage.setItem('newDonorResult', JSON.stringify({status: 'conflict', message: 'Conflitto nella prenotazione'}));
          navigate(buildPath(nextUrl))
        } else {
          sessionStorage.setItem('newDonorResult', JSON.stringify({status: false}));
          navigate(buildPath(nextUrl))
        }
      }
    }).finally(() => {
      setIsSubmitting(false);
    })
  }

  return (
    <Wrapper>
      <Base style={{ height: isMobile ? 'auto' : scale(850), width: isMobile ? undefined : scale(1200)}}>
        <BaseHeader mobileStep={mobileStep} setMobileStep={(value) => {
          if (value === 1 || value === 2){
            setMobileStep(value)
          }
        }}/>
        <BaseTitle
          title={
            isOperatore ? LABEL.DETAIL_DONATION :
              !isMobile ? 'Riepilogo dei tuoi dati' :
                (mobileStep === 1 ? 'Riepilogo dei tuoi dati' : 'Riepilogo della tua prenotazione')
          }
          sx={{textAlign: isMobile ? 'center' : undefined, marginTop: isMobile ? scale(10) : undefined}}
        />
        <ContentWrapper>
          {(!isMobile || (isMobile && mobileStep === 1)) && (
            <Box sx={{display: 'flex', flexDirection: 'column', width: scale(270), alignItems: 'center', marginLeft: isMobile ? scale(120) : 0}}>
              {!isMobile && (<Text
                text={'donatore'}
                color={theme.palette.text.secondary}
                fontFamily={FONTS.MONTSERRAT}
                fontWeight={'bold'}
                fontSize={scale(24)}
                sx={{textTransform: 'uppercase', alignSelf: 'center'}}
              />)}
              {!isMobile && (<Box
                sx={{
                  backgroundColor: theme.palette.text.secondary,
                  height: scale(2),
                  width: '100%',
                  marginTop: scale(10),
                }}
              />)}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginTop: scale(28.82),
                  gap: scale(40),
                  [theme.breakpoints.down('sm')]: {
                    justifyContent: 'center',
                  },
                }}
              >
                <ThemedTextInput
                  htmlFor={'donor-first-name'}
                  label={'Nome*'}
                  placeholder={"Inserisci nome"}
                  defaultValue={partialDonorInfo.donorInfo?.firstName}
                  errorLabel={'Inserire un nome valido'}
                  setValue={(value) => setFirstName(value)}
                  setErrorValue={setFirstNameError}
                  variant={'standard'}
                  inputSx={inputSx}
                />
                <ThemedTextInput
                  htmlFor={'donor-last-name'}
                  label={'Cognome*'}
                  placeholder={"Inserisci cognome"}
                  errorLabel={'Inserire un cognome valido'}
                  defaultValue={partialDonorInfo.donorInfo?.lastName}
                  setValue={(value) => setLastName(value)}
                  setErrorValue={setLastNameError}
                  variant={'standard'}
                  inputSx={inputSx}
                />
                <ThemedTextInput
                  htmlFor={'donor-phone'}
                  label={'Telefono*'}
                  placeholder={"Inserisci il telefono"}
                  errorLabel={'Inserire un numero valido'}
                  validate={validatePhoneNumber}
                  defaultValue={splitPhoneNumber(partialDonorInfo.donorInfo?.phone).number}
                  setValue={(value) => setPhone(value)}
                  setErrorValue={setPhoneError}
                  variant={'standard'}
                  inputSx={inputSx}
                  startAdornment={
                    <Select
                      id={'donor-phone-prefix'}
                      variant={'standard'}
                      disableUnderline
                      value={phonePrefix}
                      onChange={(event) => setPhonePrefix(event.target.value)}
                      renderValue={(val) => PHONE_PREFIXES.find((p) => p.value === val)?.name ?? val}
                      MenuProps={{PaperProps: {sx: {maxHeight: scale(320)}}}}
                      sx={{
                        marginRight: scale(6),
                        fontFamily: FONTS.MONTSERRAT,
                        fontSize: scale(16),
                        color: 'black',
                        '& .MuiSelect-select': {
                          paddingTop: 0,
                          paddingBottom: 0,
                          paddingRight: `${scale(20)} !important`,
                          minWidth: scale(48),
                        },
                      }}
                    >
                      {PHONE_PREFIXES.map((p) => (
                        <MenuItem key={p.value} value={p.value} sx={{fontFamily: FONTS.MONTSERRAT, fontSize: scale(20), color: 'black'}}>
                          {p.name}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                />
                <ThemedTextInput
                  htmlFor={'donor-cf'}
                  label={'Codice fiscale'.concat(!isOperatore ? '*' : '')}
                  placeholder={"Inserisci il codice fiscale"}
                  type={'CF'}
                  errorLabel={'Codice fiscale non valido'}
                  required={!isOperatore}
                  validate={validateTaxCode}
                  defaultValue={partialDonorInfo.donorInfo?.CF}
                  setValue={(value) => setCf(value)}
                  setErrorValue={setCFError}
                  variant={'standard'}
                  inputSx={inputSx}
                />
              </Box>
            </Box>)}
          {(!isMobile || (isMobile && mobileStep === 2)) && (
            <>
              <DateDetailedCard
                {...props}
                dayName={isMobile ? 'ore' : dateInfo.weekday}
                dayNumber={isMobile ? getTurnoHourById(raccolta, partialDonorInfo?.id_turno!!) : dateInfo.day.toString()}
                month={isMobile ? mobileDateInfo.day.concat('.').concat(mobileDateInfo.month.toString()).concat('.').concat(mobileDateInfo.year.toString()) : dateInfo.month.concat('\n')}
                year={isMobile ? '' : dateInfo.year.toString()}
                colorStyle={"secondary"}
                city={raccolta.name}
                address={raccolta.address}
                sx={{height: scale(408), paddingBottom: raccolta.name.length > 14 ? scale(20) : 0, marginLeft: isMobile ? scale(30) : undefined}}
              />
            </>
          )}
          {!isMobile && (<Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: scale(40)}}>
            <Box style={{display: 'flex', flexDirection: 'column'}}>
              <Text
                text={'tipologia'}
                color={theme.palette.text.secondary}
                fontFamily={FONTS.MONTSERRAT}
                fontWeight={700}
                fontSize={scale(24)}
                sx={{textTransform: 'uppercase', alignSelf: 'center'}}
              />
              <Box
                sx={{
                  backgroundColor: theme.palette.text.secondary,
                  height: scale(2),
                  width: '100%',
                  marginTop: scale(10),
                }}
              />
              <DateRowInfo
                IconComponent={
                  <CustomSvg
                    svg={GOCCIA_RIFLESSO}
                    sx={{
                      zIndex: 2,
                      fontSize: scale(60),
                    }}
                    color={'white'}
                  />
                }
                bgColor={partialDonorInfo.type === 'plasma' ? theme.palette.plasma.main : theme.palette.blood.main}
                colorStyle={'primary'}
                firstRowText={partialDonorInfo.type === 'plasma' ? 'Plasma' : 'Sangue'}
                iconSx={{width: scale(90), height: scale(90), borderRadius: scale(18)}}
                sx={{marginTop: scale(30), flexDirection: 'column', width: scale(170), alignItems: 'center'}}
                textSx={{
                  width: scale(170),
                  textAlign: 'center',
                  fontWeight: 700,
                  color: partialDonorInfo.type === 'plasma' ? theme.palette.plasma.main : theme.palette.blood.main
                }}
              />
            </Box>
            <Box style={{display: 'flex', flexDirection: 'column'}}>
              <Text
                text={'orario'}
                color={theme.palette.text.secondary}
                fontFamily={FONTS.MONTSERRAT}
                fontWeight={700}
                fontSize={scale(24)}
                sx={{textTransform: 'uppercase', alignSelf: 'center'}}
              />
              <Box
                sx={{
                  backgroundColor: theme.palette.text.secondary,
                  height: scale(2),
                  width: '100%',
                  marginTop: scale(10),
                }}
              />
              {getFasciaAmPmById(raccolta, partialDonorInfo?.id_fascia!!) === 1 &&
                (
                  <DateRowInfo
                    IconComponent={<QueryBuilder color={'white'} sx={{zIndex: 2, fontSize: scale(60)}}/>}
                    firstRowText={'H '.concat(getTurnoHourById(raccolta, partialDonorInfo?.id_turno!!))}
                    colorStyle={'primary'}
                    bgColor={theme.palette.white.contrastText}
                    iconSx={{width: scale(90), height: scale(90), borderRadius: scale(18)}}
                    sx={{marginTop: scale(30), flexDirection: 'column', width: scale(170), alignItems: 'center'}}
                    textSx={{width: scale(170), textAlign: 'center', fontWeight: 700}}
                  />
                )
              }
              {getFasciaAmPmById(raccolta, partialDonorInfo?.id_fascia!!) === 2 &&
                (
                  <DateRowInfo
                    IconComponent={<QueryBuilder color={'white'}
                                                 sx={{zIndex: 2, fontSize: scale(60), transform: 'rotate(90deg)'}}/>}
                    firstRowText={'H '.concat(getTurnoHourById(raccolta, partialDonorInfo?.id_turno!!))}
                    colorStyle={'primary'}
                    bgColor={theme.palette.white.contrastText}
                    iconSx={{width: scale(90), height: scale(90), borderRadius: scale(18)}}
                    sx={{marginTop: scale(30), flexDirection: 'column', width: scale(170), alignItems: 'center'}}
                    textSx={{width: scale(170), textAlign: 'center', fontWeight: 700}}
                  />
                )
              }
            </Box>
          </Box>)}
        </ContentWrapper>
        <ThemedButton
          variant="contained"
          disabled={isDisabled() || isSubmitting}
          onClick={() => {
            if (!isMobile || (isMobile && mobileStep === 2)){
              addDonorToRaccolta()
            } else {
              setMobileStep(2)
            }
          }}
        >
          <ThemedText text={'conferma'} fontWeight={600} fontSize={scale(18)} fontFamily={FONTS.MONTSERRAT}/>
        </ThemedButton>
      </Base>
    </Wrapper>
  );
}

export default OperatoreRiepilogoPrenotazione;
